define(function (require) {
	var IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/cdr/inspections/{0}/request/',
		parse: function (response) {
			var data = response.data ? response.data : response;
			return data;
		},
		url: function () {
			var url = this.urlRoot;
			if (this.id) {
				url += this.id;
			}
			return url;
		},
		sync: function (method, model, options) {
			if (method == 'create' || method == 'update' && this.captureRequestDateToCallDate === true) {
				if (model.get('scheduledDateTime')) {
					model.set({ callDateTime: model.get('scheduledDateTime') }, { silent: true });
					model.unset('scheduledDateTime', { silent: true });
				}
			}
			return Backbone.sync(method, model, options);
		}
	});
});
